import { DailyLoadProcessStatus } from './DailyLoadProcessStatus';

export const DailyLoadProcessStatuses:Map<string, string> = new Map([
  [DailyLoadProcessStatus.COMPLETED, 'Completed'],
  [DailyLoadProcessStatus.FAILED, 'Failed'],
  [DailyLoadProcessStatus.NOT_STARTED, 'Not Started'],
  [DailyLoadProcessStatus.PROCESSING, 'Processing'],
]);

export default DailyLoadProcessStatuses;
